import AnatomyV2QuickExperiment from '~/pages/anatomyV2/quickExperiment/libs/components/AnatomyV2QuickExperiment'
import { TPageProps } from '~/shared/types/commonTypes'

const QuickExperimentAnatomyV2 = (props: TPageProps) => (
  <AnatomyV2QuickExperiment {...props} />
)

export default QuickExperimentAnatomyV2
